import { pageHead } from "@app/framework/meta";
import { InvestorRelationsLandingPage } from "@modules/investor-relations/pages/InvestorRelationsLandingPage";
import { trans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export default function InvestorRelations() {
  useLoaderData();

  return <InvestorRelationsLandingPage />;
}

export const meta: MetaFunction = () => {
  return pageHead({
    title: trans("investorRelations"),
    appendAppName: true,
  });
};
